// Generated from deal.g4 by ANTLR 4.9.0-SNAPSHOT


import { ATN } from "antlr4ts/atn/ATN";
import { ATNDeserializer } from "antlr4ts/atn/ATNDeserializer";
import { CharStream } from "antlr4ts/CharStream";
import { Lexer } from "antlr4ts/Lexer";
import { LexerATNSimulator } from "antlr4ts/atn/LexerATNSimulator";
import { NotNull } from "antlr4ts/Decorators";
import { Override } from "antlr4ts/Decorators";
import { RuleContext } from "antlr4ts/RuleContext";
import { Vocabulary } from "antlr4ts/Vocabulary";
import { VocabularyImpl } from "antlr4ts/VocabularyImpl";

import * as Utils from "antlr4ts/misc/Utils";


export class dealLexer extends Lexer {
	public static readonly T__0 = 1;
	public static readonly T__1 = 2;
	public static readonly T__2 = 3;
	public static readonly T__3 = 4;
	public static readonly T__4 = 5;
	public static readonly T__5 = 6;
	public static readonly T__6 = 7;
	public static readonly T__7 = 8;
	public static readonly T__8 = 9;
	public static readonly T__9 = 10;
	public static readonly T__10 = 11;
	public static readonly T__11 = 12;
	public static readonly T__12 = 13;
	public static readonly T__13 = 14;
	public static readonly T__14 = 15;
	public static readonly T__15 = 16;
	public static readonly T__16 = 17;
	public static readonly T__17 = 18;
	public static readonly T__18 = 19;
	public static readonly T__19 = 20;
	public static readonly T__20 = 21;
	public static readonly T__21 = 22;
	public static readonly T__22 = 23;
	public static readonly T__23 = 24;
	public static readonly T__24 = 25;
	public static readonly T__25 = 26;
	public static readonly T__26 = 27;
	public static readonly T__27 = 28;
	public static readonly T__28 = 29;
	public static readonly T__29 = 30;
	public static readonly T__30 = 31;
	public static readonly T__31 = 32;
	public static readonly T__32 = 33;
	public static readonly T__33 = 34;
	public static readonly T__34 = 35;
	public static readonly T__35 = 36;
	public static readonly T__36 = 37;
	public static readonly COMMENT = 38;
	public static readonly VARTYPE = 39;
	public static readonly MOVE_DEST = 40;
	public static readonly MOVE_SOURCE = 41;
	public static readonly INTERACT_CARD = 42;
	public static readonly PLUS = 43;
	public static readonly MINUS = 44;
	public static readonly TIMES = 45;
	public static readonly WILDCARD = 46;
	public static readonly EMPTY = 47;
	public static readonly SPADES = 48;
	public static readonly HEARTS = 49;
	public static readonly CLUBS = 50;
	public static readonly DIAMONDS = 51;
	public static readonly JACK = 52;
	public static readonly QUEEN = 53;
	public static readonly KING = 54;
	public static readonly ACE = 55;
	public static readonly NUMBER = 56;
	public static readonly ID = 57;
	public static readonly CARD = 58;
	public static readonly JOKER = 59;
	public static readonly STRING = 60;
	public static readonly SPACES = 61;
	public static readonly NEWLINE = 62;

	// tslint:disable:no-trailing-whitespace
	public static readonly channelNames: string[] = [
		"DEFAULT_TOKEN_CHANNEL", "HIDDEN",
	];

	// tslint:disable:no-trailing-whitespace
	public static readonly modeNames: string[] = [
		"DEFAULT_MODE",
	];

	public static readonly ruleNames: string[] = [
		"T__0", "T__1", "T__2", "T__3", "T__4", "T__5", "T__6", "T__7", "T__8", 
		"T__9", "T__10", "T__11", "T__12", "T__13", "T__14", "T__15", "T__16", 
		"T__17", "T__18", "T__19", "T__20", "T__21", "T__22", "T__23", "T__24", 
		"T__25", "T__26", "T__27", "T__28", "T__29", "T__30", "T__31", "T__32", 
		"T__33", "T__34", "T__35", "T__36", "COMMENT", "VARTYPE", "MOVE_DEST", 
		"MOVE_SOURCE", "INTERACT_CARD", "PLUS", "MINUS", "TIMES", "WILDCARD", 
		"EMPTY", "SPADES", "HEARTS", "CLUBS", "DIAMONDS", "JACK", "QUEEN", "KING", 
		"ACE", "NUMBER", "ID", "CARD", "JOKER", "STRING", "SPACES", "NEWLINE",
	];

	private static readonly _LITERAL_NAMES: Array<string | undefined> = [
		undefined, "'define'", "';'", "'on'", "'<'", "'.'", "'>'", "'area'", "'action'", 
		"'function'", "'('", "')'", "'{'", "'}'", "','", "'move'", "'interact'", 
		"'for'", "'in'", "'if'", "'else'", "'cancel'", "'='", "'++'", "'log'", 
		"'show'", "'$'", "'['", "']'", "'=='", "'!='", "'<='", "'>='", "'=?'", 
		"'!?'", "'||'", "'&&'", "':'", undefined, undefined, "'dest'", "'source'", 
		"'@'", "'+'", "'-'", "'*'", "'?'", "'empty'", "'spades'", "'hearts'", 
		"'clubs'", "'diamonds'", "'jack'", "'queen'", "'king'", "'ace'",
	];
	private static readonly _SYMBOLIC_NAMES: Array<string | undefined> = [
		undefined, undefined, undefined, undefined, undefined, undefined, undefined, 
		undefined, undefined, undefined, undefined, undefined, undefined, undefined, 
		undefined, undefined, undefined, undefined, undefined, undefined, undefined, 
		undefined, undefined, undefined, undefined, undefined, undefined, undefined, 
		undefined, undefined, undefined, undefined, undefined, undefined, undefined, 
		undefined, undefined, undefined, "COMMENT", "VARTYPE", "MOVE_DEST", "MOVE_SOURCE", 
		"INTERACT_CARD", "PLUS", "MINUS", "TIMES", "WILDCARD", "EMPTY", "SPADES", 
		"HEARTS", "CLUBS", "DIAMONDS", "JACK", "QUEEN", "KING", "ACE", "NUMBER", 
		"ID", "CARD", "JOKER", "STRING", "SPACES", "NEWLINE",
	];
	public static readonly VOCABULARY: Vocabulary = new VocabularyImpl(dealLexer._LITERAL_NAMES, dealLexer._SYMBOLIC_NAMES, []);

	// @Override
	// @NotNull
	public get vocabulary(): Vocabulary {
		return dealLexer.VOCABULARY;
	}
	// tslint:enable:no-trailing-whitespace


	constructor(input: CharStream) {
		super(input);
		this._interp = new LexerATNSimulator(dealLexer._ATN, this);
	}

	// @Override
	public get grammarFileName(): string { return "deal.g4"; }

	// @Override
	public get ruleNames(): string[] { return dealLexer.ruleNames; }

	// @Override
	public get serializedATN(): string { return dealLexer._serializedATN; }

	// @Override
	public get channelNames(): string[] { return dealLexer.channelNames; }

	// @Override
	public get modeNames(): string[] { return dealLexer.modeNames; }

	public static readonly _serializedATN: string =
		"\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x02@\u019D\b\x01" +
		"\x04\x02\t\x02\x04\x03\t\x03\x04\x04\t\x04\x04\x05\t\x05\x04\x06\t\x06" +
		"\x04\x07\t\x07\x04\b\t\b\x04\t\t\t\x04\n\t\n\x04\v\t\v\x04\f\t\f\x04\r" +
		"\t\r\x04\x0E\t\x0E\x04\x0F\t\x0F\x04\x10\t\x10\x04\x11\t\x11\x04\x12\t" +
		"\x12\x04\x13\t\x13\x04\x14\t\x14\x04\x15\t\x15\x04\x16\t\x16\x04\x17\t" +
		"\x17\x04\x18\t\x18\x04\x19\t\x19\x04\x1A\t\x1A\x04\x1B\t\x1B\x04\x1C\t" +
		"\x1C\x04\x1D\t\x1D\x04\x1E\t\x1E\x04\x1F\t\x1F\x04 \t \x04!\t!\x04\"\t" +
		"\"\x04#\t#\x04$\t$\x04%\t%\x04&\t&\x04\'\t\'\x04(\t(\x04)\t)\x04*\t*\x04" +
		"+\t+\x04,\t,\x04-\t-\x04.\t.\x04/\t/\x040\t0\x041\t1\x042\t2\x043\t3\x04" +
		"4\t4\x045\t5\x046\t6\x047\t7\x048\t8\x049\t9\x04:\t:\x04;\t;\x04<\t<\x04" +
		"=\t=\x04>\t>\x04?\t?\x03\x02\x03\x02\x03\x02\x03\x02\x03\x02\x03\x02\x03" +
		"\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x04\x03\x05\x03\x05\x03\x06\x03" +
		"\x06\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03\b\x03\b\x03\t\x03\t\x03\t\x03" +
		"\t\x03\t\x03\t\x03\t\x03\n\x03\n\x03\n\x03\n\x03\n\x03\n\x03\n\x03\n\x03" +
		"\n\x03\v\x03\v\x03\f\x03\f\x03\r\x03\r\x03\x0E\x03\x0E\x03\x0F\x03\x0F" +
		"\x03\x10\x03\x10\x03\x10\x03\x10\x03\x10\x03\x11\x03\x11\x03\x11\x03\x11" +
		"\x03\x11\x03\x11\x03\x11\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x03\x12" +
		"\x03\x13\x03\x13\x03\x13\x03\x14\x03\x14\x03\x14\x03\x15\x03\x15\x03\x15" +
		"\x03\x15\x03\x15\x03\x16\x03\x16\x03\x16\x03\x16\x03\x16\x03\x16\x03\x16" +
		"\x03\x17\x03\x17\x03\x18\x03\x18\x03\x18\x03\x19\x03\x19\x03\x19\x03\x19" +
		"\x03\x1A\x03\x1A\x03\x1A\x03\x1A\x03\x1A\x03\x1B\x03\x1B\x03\x1C\x03\x1C" +
		"\x03\x1D\x03\x1D\x03\x1E\x03\x1E\x03\x1E\x03\x1F\x03\x1F\x03\x1F\x03 " +
		"\x03 \x03 \x03!\x03!\x03!\x03\"\x03\"\x03\"\x03#\x03#\x03#\x03$\x03$\x03" +
		"$\x03%\x03%\x03%\x03&\x03&\x03\'\x03\'\x03\'\x03\'\x07\'\u0107\n\'\f\'" +
		"\x0E\'\u010A\v\'\x03\'\x03\'\x03(\x03(\x03(\x03(\x03(\x03(\x03(\x03(\x03" +
		"(\x03(\x03(\x03(\x03(\x05(\u011B\n(\x03)\x03)\x03)\x03)\x03)\x03*\x03" +
		"*\x03*\x03*\x03*\x03*\x03*\x03+\x03+\x03,\x03,\x03-\x03-\x03.\x03.\x03" +
		"/\x03/\x030\x030\x030\x030\x030\x030\x031\x031\x031\x031\x031\x031\x03" +
		"1\x032\x032\x032\x032\x032\x032\x032\x033\x033\x033\x033\x033\x033\x03" +
		"4\x034\x034\x034\x034\x034\x034\x034\x034\x035\x035\x035\x035\x035\x03" +
		"6\x036\x036\x036\x036\x036\x037\x037\x037\x037\x037\x038\x038\x038\x03" +
		"8\x039\x059\u016B\n9\x039\x069\u016E\n9\r9\x0E9\u016F\x03:\x06:\u0173" +
		"\n:\r:\x0E:\u0174\x03;\x03;\x03;\x03;\x05;\u017B\n;\x03;\x03;\x05;\u017F" +
		"\n;\x03<\x03<\x03<\x03<\x03<\x03<\x03=\x03=\x07=\u0189\n=\f=\x0E=\u018C" +
		"\v=\x03=\x03=\x03>\x06>\u0191\n>\r>\x0E>\u0192\x03>\x03>\x03?\x06?\u0198" +
		"\n?\r?\x0E?\u0199\x03?\x03?\x02\x02\x02@\x03\x02\x03\x05\x02\x04\x07\x02" +
		"\x05\t\x02\x06\v\x02\x07\r\x02\b\x0F\x02\t\x11\x02\n\x13\x02\v\x15\x02" +
		"\f\x17\x02\r\x19\x02\x0E\x1B\x02\x0F\x1D\x02\x10\x1F\x02\x11!\x02\x12" +
		"#\x02\x13%\x02\x14\'\x02\x15)\x02\x16+\x02\x17-\x02\x18/\x02\x191\x02" +
		"\x1A3\x02\x1B5\x02\x1C7\x02\x1D9\x02\x1E;\x02\x1F=\x02 ?\x02!A\x02\"C" +
		"\x02#E\x02$G\x02%I\x02&K\x02\'M\x02(O\x02)Q\x02*S\x02+U\x02,W\x02-Y\x02" +
		".[\x02/]\x020_\x021a\x022c\x023e\x024g\x025i\x026k\x027m\x028o\x029q\x02" +
		":s\x02;u\x02<w\x02=y\x02>{\x02?}\x02@\x03\x02\x0E\x04\x02\f\f\x0F\x0F" +
		"\x03\x022;\x05\x02C\\aac|\t\x024;CCLMSScclmss\b\x02EFJJUUefjjuu\x04\x02" +
		"LLll\x04\x02QQqq\x04\x02MMmm\x04\x02GGgg\x04\x02TTtt\x03\x02$$\x05\x02" +
		"\v\f\x0F\x0F\"\"\x02\u01A7\x02\x03\x03\x02\x02\x02\x02\x05\x03\x02\x02" +
		"\x02\x02\x07\x03\x02\x02\x02\x02\t\x03\x02\x02\x02\x02\v\x03\x02\x02\x02" +
		"\x02\r\x03\x02\x02\x02\x02\x0F\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02" +
		"\x02\x13\x03\x02\x02\x02\x02\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02" +
		"\x02\x19\x03\x02\x02\x02\x02\x1B\x03\x02\x02\x02\x02\x1D\x03\x02\x02\x02" +
		"\x02\x1F\x03\x02\x02\x02\x02!\x03\x02\x02\x02\x02#\x03\x02\x02\x02\x02" +
		"%\x03\x02\x02\x02\x02\'\x03\x02\x02\x02\x02)\x03\x02\x02\x02\x02+\x03" +
		"\x02\x02\x02\x02-\x03\x02\x02\x02\x02/\x03\x02\x02\x02\x021\x03\x02\x02" +
		"\x02\x023\x03\x02\x02\x02\x025\x03\x02\x02\x02\x027\x03\x02\x02\x02\x02" +
		"9\x03\x02\x02\x02\x02;\x03\x02\x02\x02\x02=\x03\x02\x02\x02\x02?\x03\x02" +
		"\x02\x02\x02A\x03\x02\x02\x02\x02C\x03\x02\x02\x02\x02E\x03\x02\x02\x02" +
		"\x02G\x03\x02\x02\x02\x02I\x03\x02\x02\x02\x02K\x03\x02\x02\x02\x02M\x03" +
		"\x02\x02\x02\x02O\x03\x02\x02\x02\x02Q\x03\x02\x02\x02\x02S\x03\x02\x02" +
		"\x02\x02U\x03\x02\x02\x02\x02W\x03\x02\x02\x02\x02Y\x03\x02\x02\x02\x02" +
		"[\x03\x02\x02\x02\x02]\x03\x02\x02\x02\x02_\x03\x02\x02\x02\x02a\x03\x02" +
		"\x02\x02\x02c\x03\x02\x02\x02\x02e\x03\x02\x02\x02\x02g\x03\x02\x02\x02" +
		"\x02i\x03\x02\x02\x02\x02k\x03\x02\x02\x02\x02m\x03\x02\x02\x02\x02o\x03" +
		"\x02\x02\x02\x02q\x03\x02\x02\x02\x02s\x03\x02\x02\x02\x02u\x03\x02\x02" +
		"\x02\x02w\x03\x02\x02\x02\x02y\x03\x02\x02\x02\x02{\x03\x02\x02\x02\x02" +
		"}\x03\x02\x02\x02\x03\x7F\x03\x02\x02\x02\x05\x86\x03\x02\x02\x02\x07" +
		"\x88\x03\x02\x02\x02\t\x8B\x03\x02\x02\x02\v\x8D\x03\x02\x02\x02\r\x8F" +
		"\x03\x02\x02\x02\x0F\x91\x03\x02\x02\x02\x11\x96\x03\x02\x02\x02\x13\x9D" +
		"\x03\x02\x02\x02\x15\xA6\x03\x02\x02\x02\x17\xA8\x03\x02\x02\x02\x19\xAA" +
		"\x03\x02\x02\x02\x1B\xAC\x03\x02\x02\x02\x1D\xAE\x03\x02\x02\x02\x1F\xB0" +
		"\x03\x02\x02\x02!\xB5\x03\x02\x02\x02#\xBE\x03\x02\x02\x02%\xC2\x03\x02" +
		"\x02\x02\'\xC5\x03\x02\x02\x02)\xC8\x03\x02\x02\x02+\xCD\x03\x02\x02\x02" +
		"-\xD4\x03\x02\x02\x02/\xD6\x03\x02\x02\x021\xD9\x03\x02\x02\x023\xDD\x03" +
		"\x02\x02\x025\xE2\x03\x02\x02\x027\xE4\x03\x02\x02\x029\xE6\x03\x02\x02" +
		"\x02;\xE8\x03\x02\x02\x02=\xEB\x03\x02\x02\x02?\xEE\x03\x02\x02\x02A\xF1" +
		"\x03\x02\x02\x02C\xF4\x03\x02\x02\x02E\xF7\x03\x02\x02\x02G\xFA\x03\x02" +
		"\x02\x02I\xFD\x03\x02\x02\x02K\u0100\x03\x02\x02\x02M\u0102\x03\x02\x02" +
		"\x02O\u011A\x03\x02\x02\x02Q\u011C\x03\x02\x02\x02S\u0121\x03\x02\x02" +
		"\x02U\u0128\x03\x02\x02\x02W\u012A\x03\x02\x02\x02Y\u012C\x03\x02\x02" +
		"\x02[\u012E\x03\x02\x02\x02]\u0130\x03\x02\x02\x02_\u0132\x03\x02\x02" +
		"\x02a\u0138\x03\x02\x02\x02c\u013F\x03\x02\x02\x02e\u0146\x03\x02\x02" +
		"\x02g\u014C\x03\x02\x02\x02i\u0155\x03\x02\x02\x02k\u015A\x03\x02\x02" +
		"\x02m\u0160\x03\x02\x02\x02o\u0165\x03\x02\x02\x02q\u016A\x03\x02\x02" +
		"\x02s\u0172\x03\x02\x02\x02u\u0176\x03\x02\x02\x02w\u0180\x03\x02\x02" +
		"\x02y\u0186\x03\x02\x02\x02{\u0190\x03\x02\x02\x02}\u0197\x03\x02\x02" +
		"\x02\x7F\x80\x07f\x02\x02\x80\x81\x07g\x02\x02\x81\x82\x07h\x02\x02\x82" +
		"\x83\x07k\x02\x02\x83\x84\x07p\x02\x02\x84\x85\x07g\x02\x02\x85\x04\x03" +
		"\x02\x02\x02\x86\x87\x07=\x02\x02\x87\x06\x03\x02\x02\x02\x88\x89\x07" +
		"q\x02\x02\x89\x8A\x07p\x02\x02\x8A\b\x03\x02\x02\x02\x8B\x8C\x07>\x02" +
		"\x02\x8C\n\x03\x02\x02\x02\x8D\x8E\x070\x02\x02\x8E\f\x03\x02\x02\x02" +
		"\x8F\x90\x07@\x02\x02\x90\x0E\x03\x02\x02\x02\x91\x92\x07c\x02\x02\x92" +
		"\x93\x07t\x02\x02\x93\x94\x07g\x02\x02\x94\x95\x07c\x02\x02\x95\x10\x03" +
		"\x02\x02\x02\x96\x97\x07c\x02\x02\x97\x98\x07e\x02\x02\x98\x99\x07v\x02" +
		"\x02\x99\x9A\x07k\x02\x02\x9A\x9B\x07q\x02\x02\x9B\x9C\x07p\x02\x02\x9C" +
		"\x12\x03\x02\x02\x02\x9D\x9E\x07h\x02\x02\x9E\x9F\x07w\x02\x02\x9F\xA0" +
		"\x07p\x02\x02\xA0\xA1\x07e\x02\x02\xA1\xA2\x07v\x02\x02\xA2\xA3\x07k\x02" +
		"\x02\xA3\xA4\x07q\x02\x02\xA4\xA5\x07p\x02\x02\xA5\x14\x03\x02\x02\x02" +
		"\xA6\xA7\x07*\x02\x02\xA7\x16\x03\x02\x02\x02\xA8\xA9\x07+\x02\x02\xA9" +
		"\x18\x03\x02\x02\x02\xAA\xAB\x07}\x02\x02\xAB\x1A\x03\x02\x02\x02\xAC" +
		"\xAD\x07\x7F\x02\x02\xAD\x1C\x03\x02\x02\x02\xAE\xAF\x07.\x02\x02\xAF" +
		"\x1E\x03\x02\x02\x02\xB0\xB1\x07o\x02\x02\xB1\xB2\x07q\x02\x02\xB2\xB3" +
		"\x07x\x02\x02\xB3\xB4\x07g\x02\x02\xB4 \x03\x02\x02\x02\xB5\xB6\x07k\x02" +
		"\x02\xB6\xB7\x07p\x02\x02\xB7\xB8\x07v\x02\x02\xB8\xB9\x07g\x02\x02\xB9" +
		"\xBA\x07t\x02\x02\xBA\xBB\x07c\x02\x02\xBB\xBC\x07e\x02\x02\xBC\xBD\x07" +
		"v\x02\x02\xBD\"\x03\x02\x02\x02\xBE\xBF\x07h\x02\x02\xBF\xC0\x07q\x02" +
		"\x02\xC0\xC1\x07t\x02\x02\xC1$\x03\x02\x02\x02\xC2\xC3\x07k\x02\x02\xC3" +
		"\xC4\x07p\x02\x02\xC4&\x03\x02\x02\x02\xC5\xC6\x07k\x02\x02\xC6\xC7\x07" +
		"h\x02\x02\xC7(\x03\x02\x02\x02\xC8\xC9\x07g\x02\x02\xC9\xCA\x07n\x02\x02" +
		"\xCA\xCB\x07u\x02\x02\xCB\xCC\x07g\x02\x02\xCC*\x03\x02\x02\x02\xCD\xCE" +
		"\x07e\x02\x02\xCE\xCF\x07c\x02\x02\xCF\xD0\x07p\x02\x02\xD0\xD1\x07e\x02" +
		"\x02\xD1\xD2\x07g\x02\x02\xD2\xD3\x07n\x02\x02\xD3,\x03\x02\x02\x02\xD4" +
		"\xD5\x07?\x02\x02\xD5.\x03\x02\x02\x02\xD6\xD7\x07-\x02\x02\xD7\xD8\x07" +
		"-\x02\x02\xD80\x03\x02\x02\x02\xD9\xDA\x07n\x02\x02\xDA\xDB\x07q\x02\x02" +
		"\xDB\xDC\x07i\x02\x02\xDC2\x03\x02\x02\x02\xDD\xDE\x07u\x02\x02\xDE\xDF" +
		"\x07j\x02\x02\xDF\xE0\x07q\x02\x02\xE0\xE1\x07y\x02\x02\xE14\x03\x02\x02" +
		"\x02\xE2\xE3\x07&\x02\x02\xE36\x03\x02\x02\x02\xE4\xE5\x07]\x02\x02\xE5" +
		"8\x03\x02\x02\x02\xE6\xE7\x07_\x02\x02\xE7:\x03\x02\x02\x02\xE8\xE9\x07" +
		"?\x02\x02\xE9\xEA\x07?\x02\x02\xEA<\x03\x02\x02\x02\xEB\xEC\x07#\x02\x02" +
		"\xEC\xED\x07?\x02\x02\xED>\x03\x02\x02\x02\xEE\xEF\x07>\x02\x02\xEF\xF0" +
		"\x07?\x02\x02\xF0@\x03\x02\x02\x02\xF1\xF2\x07@\x02\x02\xF2\xF3\x07?\x02" +
		"\x02\xF3B\x03\x02\x02\x02\xF4\xF5\x07?\x02\x02\xF5\xF6\x07A\x02\x02\xF6" +
		"D\x03\x02\x02\x02\xF7\xF8\x07#\x02\x02\xF8\xF9\x07A\x02\x02\xF9F\x03\x02" +
		"\x02\x02\xFA\xFB\x07~\x02\x02\xFB\xFC\x07~\x02\x02\xFCH\x03\x02\x02\x02" +
		"\xFD\xFE\x07(\x02\x02\xFE\xFF\x07(\x02\x02\xFFJ\x03\x02\x02\x02\u0100" +
		"\u0101\x07<\x02\x02\u0101L\x03\x02\x02\x02\u0102\u0103\x071\x02\x02\u0103" +
		"\u0104\x071\x02\x02\u0104\u0108\x03\x02\x02\x02\u0105\u0107\n\x02\x02" +
		"\x02\u0106\u0105\x03\x02\x02\x02\u0107\u010A\x03\x02\x02\x02\u0108\u0106" +
		"\x03\x02\x02\x02\u0108\u0109\x03\x02\x02\x02\u0109\u010B\x03\x02\x02\x02" +
		"\u010A\u0108\x03\x02\x02\x02\u010B\u010C\b\'\x02\x02\u010CN\x03\x02\x02" +
		"\x02\u010D\u010E\x07k\x02\x02\u010E\u010F\x07p\x02\x02\u010F\u011B\x07" +
		"v\x02\x02\u0110\u0111\x07e\x02\x02\u0111\u0112\x07c\x02\x02\u0112\u0113" +
		"\x07t\x02\x02\u0113\u011B\x07f\x02\x02\u0114\u0115\x07u\x02\x02\u0115" +
		"\u0116\x07v\x02\x02\u0116\u0117\x07t\x02\x02\u0117\u0118\x07k\x02\x02" +
		"\u0118\u0119\x07p\x02\x02\u0119\u011B\x07i\x02\x02\u011A\u010D\x03\x02" +
		"\x02\x02\u011A\u0110\x03\x02\x02\x02\u011A\u0114\x03\x02\x02\x02\u011B" +
		"P\x03\x02\x02\x02\u011C\u011D\x07f\x02\x02\u011D\u011E\x07g\x02\x02\u011E" +
		"\u011F\x07u\x02\x02\u011F\u0120\x07v\x02\x02\u0120R\x03\x02\x02\x02\u0121" +
		"\u0122\x07u\x02\x02\u0122\u0123\x07q\x02\x02\u0123\u0124\x07w\x02\x02" +
		"\u0124\u0125\x07t\x02\x02\u0125\u0126\x07e\x02\x02\u0126\u0127\x07g\x02" +
		"\x02\u0127T\x03\x02\x02\x02\u0128\u0129\x07B\x02\x02\u0129V\x03\x02\x02" +
		"\x02\u012A\u012B\x07-\x02\x02\u012BX\x03\x02\x02\x02\u012C\u012D\x07/" +
		"\x02\x02\u012DZ\x03\x02\x02\x02\u012E\u012F\x07,\x02\x02\u012F\\\x03\x02" +
		"\x02\x02\u0130\u0131\x07A\x02\x02\u0131^\x03\x02\x02\x02\u0132\u0133\x07" +
		"g\x02\x02\u0133\u0134\x07o\x02\x02\u0134\u0135\x07r\x02\x02\u0135\u0136" +
		"\x07v\x02\x02\u0136\u0137\x07{\x02\x02\u0137`\x03\x02\x02\x02\u0138\u0139" +
		"\x07u\x02\x02\u0139\u013A\x07r\x02\x02\u013A\u013B\x07c\x02\x02\u013B" +
		"\u013C\x07f\x02\x02\u013C\u013D\x07g\x02\x02\u013D\u013E\x07u\x02\x02" +
		"\u013Eb\x03\x02\x02\x02\u013F\u0140\x07j\x02\x02\u0140\u0141\x07g\x02" +
		"\x02\u0141\u0142\x07c\x02\x02\u0142\u0143\x07t\x02\x02\u0143\u0144\x07" +
		"v\x02\x02\u0144\u0145\x07u\x02\x02\u0145d\x03\x02\x02\x02\u0146\u0147" +
		"\x07e\x02\x02\u0147\u0148\x07n\x02\x02\u0148\u0149\x07w\x02\x02\u0149" +
		"\u014A\x07d\x02\x02\u014A\u014B\x07u\x02\x02\u014Bf\x03\x02\x02\x02\u014C" +
		"\u014D\x07f\x02\x02\u014D\u014E\x07k\x02\x02\u014E\u014F\x07c\x02\x02" +
		"\u014F\u0150\x07o\x02\x02\u0150\u0151\x07q\x02\x02\u0151\u0152\x07p\x02" +
		"\x02\u0152\u0153\x07f\x02\x02\u0153\u0154\x07u\x02\x02\u0154h\x03\x02" +
		"\x02\x02\u0155\u0156\x07l\x02\x02\u0156\u0157\x07c\x02\x02\u0157\u0158" +
		"\x07e\x02\x02\u0158\u0159\x07m\x02\x02\u0159j\x03\x02\x02\x02\u015A\u015B" +
		"\x07s\x02\x02\u015B\u015C\x07w\x02\x02\u015C\u015D\x07g\x02\x02\u015D" +
		"\u015E\x07g\x02\x02\u015E\u015F\x07p\x02\x02\u015Fl\x03\x02\x02\x02\u0160" +
		"\u0161\x07m\x02\x02\u0161\u0162\x07k\x02\x02\u0162\u0163\x07p\x02\x02" +
		"\u0163\u0164\x07i\x02\x02\u0164n\x03\x02\x02\x02\u0165\u0166\x07c\x02" +
		"\x02\u0166\u0167\x07e\x02\x02\u0167\u0168\x07g\x02\x02\u0168p\x03\x02" +
		"\x02\x02\u0169\u016B\x07/\x02\x02\u016A\u0169\x03\x02\x02\x02\u016A\u016B" +
		"\x03\x02\x02\x02\u016B\u016D\x03\x02\x02\x02\u016C\u016E\t\x03\x02\x02" +
		"\u016D\u016C\x03\x02\x02\x02\u016E\u016F\x03\x02\x02\x02\u016F\u016D\x03" +
		"\x02\x02\x02\u016F\u0170\x03\x02\x02\x02\u0170r\x03\x02\x02\x02\u0171" +
		"\u0173\t\x04\x02\x02\u0172\u0171\x03\x02\x02\x02\u0173\u0174\x03\x02\x02" +
		"\x02\u0174\u0172\x03\x02\x02\x02\u0174\u0175\x03\x02\x02\x02\u0175t\x03" +
		"\x02\x02\x02\u0176\u017E\x07%\x02\x02\u0177\u0178\x073\x02\x02\u0178\u017B" +
		"\x072\x02\x02\u0179\u017B\t\x05\x02\x02\u017A\u0177\x03\x02\x02\x02\u017A" +
		"\u0179\x03\x02\x02\x02\u017B\u017C\x03\x02\x02\x02\u017C\u017F\t\x06\x02" +
		"\x02\u017D\u017F\x05w<\x02\u017E\u017A\x03\x02\x02\x02\u017E\u017D\x03" +
		"\x02\x02\x02\u017Fv\x03\x02\x02\x02\u0180\u0181\t\x07\x02\x02\u0181\u0182" +
		"\t\b\x02\x02\u0182\u0183\t\t\x02\x02\u0183\u0184\t\n\x02\x02\u0184\u0185" +
		"\t\v\x02\x02\u0185x\x03\x02\x02\x02\u0186\u018A\x07$\x02\x02\u0187\u0189" +
		"\n\f\x02\x02\u0188\u0187\x03\x02\x02\x02\u0189\u018C\x03\x02\x02\x02\u018A" +
		"\u0188\x03\x02\x02\x02\u018A\u018B\x03\x02\x02\x02\u018B\u018D\x03\x02" +
		"\x02\x02\u018C\u018A\x03\x02\x02\x02\u018D\u018E\x07$\x02\x02\u018Ez\x03" +
		"\x02\x02\x02\u018F\u0191\t\r\x02\x02\u0190\u018F\x03\x02\x02\x02\u0191" +
		"\u0192\x03\x02\x02\x02\u0192\u0190\x03\x02\x02\x02\u0192\u0193\x03\x02" +
		"\x02\x02\u0193\u0194\x03\x02\x02\x02\u0194\u0195\b>\x02\x02\u0195|\x03" +
		"\x02\x02\x02\u0196\u0198\t\x02\x02\x02\u0197\u0196\x03\x02\x02\x02\u0198" +
		"\u0199\x03\x02\x02\x02\u0199\u0197\x03\x02\x02\x02\u0199\u019A\x03\x02" +
		"\x02\x02\u019A\u019B\x03\x02\x02\x02\u019B\u019C\b?\x02\x02\u019C~\x03" +
		"\x02\x02\x02\r\x02\u0108\u011A\u016A\u016F\u0174\u017A\u017E\u018A\u0192" +
		"\u0199\x03\b\x02\x02";
	public static __ATN: ATN;
	public static get _ATN(): ATN {
		if (!dealLexer.__ATN) {
			dealLexer.__ATN = new ATNDeserializer().deserialize(Utils.toCharArray(dealLexer._serializedATN));
		}

		return dealLexer.__ATN;
	}

}

